export enum ResourceID {
  // Models
  CannonModel,
  CannonBallModel,
  RocketModel,
  RocketPassiveTexture,
  MineModel,
  MineBaseColor,
  MineEmissive,
  MineORM,
  TableTopModel,
  RoundedTableTopModel,
  TableLegModel,
  BoxModel,
  DoorModel,
  FlagModel,
  ConPModel,
  Block1x1Model,
  Block1x2Model,
  Block1x3Model,
  Block1x4Model,
  Block1x5Model,
  Block2x2Model,
  BlockDestroyModel,
  Jam1x1Model,
  Jam1x2Model,
  Jam1x3Model,
  CannedBlockCube1x1Model,
  CannedBlockCube1x2Model,
  CannedBlockCube1x3Model,
  CylinderColored1x1Model,
  CylinderColored1x2Model,
  CylinderColored1x3Model,
  CylinderGrey1x1Model,
  CylinderGrey1x2Model,
  CylinderGrey1x3Model,
  IceModel,
  PlasticBlock1x1Model,
  PlasticBlock1x2Model,
  PlasticBlock1x3Model,
  PlasticBlock1x4Model,
  PlasticBlock1x5Model,
  PlasticBlock2x2Model,
  StoneBlock1x1Model,
  StoneBlock1x2Model,
  StoneBlock1x3Model,
  StoneBlock1x4Model,
  StoneBlock2x2Model,
  Column1x1Model,
  Column1x2Model,
  Column1x3Model,
  Column1x4Model,
  RoundColumn1x1Model,
  RoundColumn1x2Model,
  RoundColumn1x3Model,
  RoundColumn1x4Model,
  ConeCrownModel,
  ConeModel,
  TreeBlock1x1Model,
  TreeBlock1x2Model,
  TreeBlock1x3Model,
  TreeBlock1x4Model,
  TreeBlock1x5Model,
  WatermelonModel,
  Particle1Model,
  Particle2Model,

  // Barriers — obstacles bolted to the tabletop, not breakable blocks. One
  // shared material (barrier_M), so the parts combine into a single barrier.
  BarrierBearingModel,
  BarrierBladeModel,
  BarrierHammerModel,
  BarrierPillarModel,
  
  // Textures
  BackgroundTexture,
  ChallengeBackgroundTexture,
  ChallengeTopTexture,
  CloudTexture,
  AirBalloonTexture,
  BackgroundCastleTexture,
  StoneTexture,
  BrickDebrisTexture,
  ColumnTexture,
  RoundColumnTexture,
  StoneNormal,
  ColumnNormal,
  RoundColumnNormal,
  PurpleBoxTexture,
  GreenBoxTexture,
  AuthoredBoxNormal,
  PurpleBox2x2Texture,
  GreenBox2x2Texture,
  Block2x2Normal,
  JarCherryTexture,
  JarPlumTexture,
  JarLemonTexture,
  JarFigTexture,
  SquareCanRedTexture,
  SquareCanOrangeTexture,
  SquareCanYellowTexture,
  SquareCanGreenTexture,
  SquareCanLightBlueTexture,
  SquareCanBlueTexture,
  SquareCanPinkTexture,
  MetalNormalMap,
  CylinderRedTexture,
  CylinderOrangeTexture,
  CylinderYellowTexture,
  CylinderGreenTexture,
  CylinderLightBlueTexture,
  CylinderBlueTexture,
  CylinderPinkTexture,
  IronCanAltTexture,
  IronCanNormal,
  ConeGoldenTexture,
  ConeRedTexture,
  ConeTwoNormalTexture,
  ConeV3GoldenTexture,
  ConeV3RedTexture,
  ConeV3OrangeTexture,
  ConeV3YellowTexture,
  ConeV3GreenTexture,
  ConeV3LightBlueTexture,
  ConeV3BlueTexture,
  ConeV3PinkTexture,
  ConeV3NormalTexture,
  IceSmallTexture,
  IceBigTexture,
  IceGiantTexture,
  IceCrackedTexture,
  IceNormalTexture,
  IceCrackedNormalTexture,
  PlasticPinkTexture,
  PlasticPink2x2Texture,
  PlasticRedTexture,
  PlasticRed2x2Texture,
  PlasticYellowTexture,
  PlasticYellow2x2Texture,
  PlasticGreenTexture,
  PlasticGreen2x2Texture,
  PlasticBlueTexture,
  PlasticBlue2x2Texture,
  PlasticOrangeTexture,
  PlasticOrange2x2Texture,
  PlasticPurpleTexture,
  PlasticPurple2x2Texture,
  PlasticNewTexture,
  PlasticNewNormal,
  Plastic2x2Normal,
  PlasticLightBlueTexture,
  PlasticLightBlue2x2Texture,
  TableBaseMap,
  TableBlueBaseMap,
  TableGreyBaseMap,
  TableGreyVioletBaseMap,
  TableRedBaseMap,
  TableVioletBaseMap,
  CannonBaseMap,
  CannonNormalMap,
  CannonModelBaseMap,
  CannonModelNormalMap,
  RocketTexture,
  TreeTexture,
  TreeNormalMap,
  WatermelonTexture,
  BarrierTexture,
  BarrierNormal,
  
  // VFX ================================================================================================================
  Smog,
  Fire,

  // Jam
  JamCherryTexture,
  JamFigTexture,
  JamLemonTexture,
  JamPlumTexture,

  // Fluid Particles
  FluidParticle1,
  FluidParticle2,
  FluidParticle3,

  // Watermelon
  WatermelonJuiceTexture,
    
  // Glows
  CircleGlow1,
  CircleGlow2,
  EllipseGlow1,
  SparkGlow4,
  WaveGlow1,
  WaveGlow2,
  ShockwaveGlow1,
  ShockwaveGlow2,
  ShockwaveGlow3,

  // Splinters & Shards
  SplinterStone1,
  SplinterStone2,
  SplinterStone3,
  SplinterStone4,
  SplinterStone5,

  SplinterIce1,
  SplinterIce2,
  SplinterIce3,
  SplinterIce4,
  SplinterIce5,

  SplinterWood1,
  SplinterWood2,
  SplinterWood3,
  SplinterWood4,
  SplinterWood5,

  SplinterBrick1,
  SplinterBrick2,
  SplinterBrick3,
  SplinterBrick4,
  SplinterBrick5,

  SplinterColumn1,
  SplinterColumn2,
  SplinterColumn3,
  SplinterColumn4,
  SplinterColumn5,

  SplinterGreenBox1,
  SplinterGreenBox2,
  SplinterGreenBox3,
  SplinterGreenBox4,
  SplinterGreenBox5,

  SplinterPurpleBox1,
  SplinterPurpleBox2,
  SplinterPurpleBox3,
  SplinterPurpleBox4,
  SplinterPurpleBox5,

  SplinterPlasticBlue1,
  SplinterPlasticBlue2,
  SplinterPlasticBlue3,
  SplinterPlasticBlue4,
  SplinterPlasticBlue5,

  SplinterPlasticGreen1,
  SplinterPlasticGreen2,
  SplinterPlasticGreen3,
  SplinterPlasticGreen4,
  SplinterPlasticGreen5,

  SplinterPlasticLightBlue1,
  SplinterPlasticLightBlue2,
  SplinterPlasticLightBlue3,
  SplinterPlasticLightBlue4,
  SplinterPlasticLightBlue5,

  SplinterPlasticOrange1,
  SplinterPlasticOrange2,
  SplinterPlasticOrange3,
  SplinterPlasticOrange4,
  SplinterPlasticOrange5,

  SplinterPlasticPink1,
  SplinterPlasticPink2,
  SplinterPlasticPink3,
  SplinterPlasticPink4,
  SplinterPlasticPink5,

  SplinterPlasticPurple1,
  SplinterPlasticPurple2,
  SplinterPlasticPurple3,
  SplinterPlasticPurple4,
  SplinterPlasticPurple5,

  SplinterPlasticRed1,
  SplinterPlasticRed2,
  SplinterPlasticRed3,
  SplinterPlasticRed4,
  SplinterPlasticRed5,

  SplinterPlasticYellow1,
  SplinterPlasticYellow2,
  SplinterPlasticYellow3,
  SplinterPlasticYellow4,
  SplinterPlasticYellow5,

  GlassShard1,
  GlassShard2,
  GlassShard3,
  GlassShard4,

  // Noises Textures
  NoisePerlinTexture,
  CloudNoiseTexture,
  VornoiNoiseTexture,
}
